import type { OutputTypeEnum } from "./types";
export type { OutputTypeEnum } from "./types";

export const outputTypeValues: OutputTypeEnum[] = [
  "markdown",
  "bulletpoints",
  "table",
  "narrative",
  "chart",
  "kpi",
  "timeline",
];

const outputTypeValueSet = new Set<string>(outputTypeValues);

export function isOutputTypeEnum(value: string): value is OutputTypeEnum {
  return outputTypeValueSet.has(value);
}

export function formatOutputTypeLabel(value: OutputTypeEnum): string {
  return `${value.charAt(0).toUpperCase()}${value.slice(1)}`;
}

export function parseOutputType(value: unknown): OutputTypeEnum | null {
  if (typeof value !== "string") return null;
  const normalized = value.trim().toLowerCase();

  if (normalized === "bullets") return "bulletpoints";
  if (!isOutputTypeEnum(normalized)) return null;
  return normalized;
}

export function normalizeOutputTypes(
  values: OutputTypeEnum[] | null | undefined,
): OutputTypeEnum[] {
  const valueSet = new Set(values ?? []);
  return outputTypeValues.filter((value) => valueSet.has(value));
}

export function parseOutputTypes(values: unknown): OutputTypeEnum[] {
  if (!Array.isArray(values)) return [];

  const parsed = values
    .map((value) => parseOutputType(value))
    .filter((value): value is OutputTypeEnum => value !== null);

  return normalizeOutputTypes(parsed);
}
